import {
    GET_LOADER_STATUS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_LOADER_STATUS:
            return {
                ...state,
                SUBMIT_loading: false,
                loaderStatus: action.loaderStatus,
            }
        default:
            return state
    }
}